import React from 'react';

const Graph_Chart_js = () => {
    return (
        <div>Graph_Chart_js Component</div>
    );
}

export default Graph_Chart_js;
